import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { authFetch } from './authFetch';

export interface AvUsageItem {
  usageType: 'cohort' | 'analytical_dataset' | 'analytical_variable';
  id: string;
  name: string;
  // Project the usage lives in — the AV being looked up can be org-scoped,
  // so usages may span multiple projects and each row carries its own.
  projectId: string | null;
  // Latest cohort/analytical-dataset version id for versioned usage types;
  // null for analytical_variable usages, which have no version segment.
  versionId: string | null;
}

export interface AvUsageResponse {
  analyticalVariableId: string;
  isUsed: boolean;
  usageCount: number;
  usages: AvUsageItem[];
}

export const useAnalyticalVariableUsage = (
  avId: string | null | undefined,
  enabled = true
): UseQueryResult<{ data: AvUsageResponse }> =>
  useQuery({
    queryKey: ['analytical-variables', 'usage', avId ?? ''],
    queryFn: async () =>
      authFetch<{ data: AvUsageResponse }>(
        `/analytical-variables/${encodeURIComponent(avId ?? '')}/usage`
      ),
    enabled: enabled && !!avId,
    staleTime: 5 * 60 * 1000,
  });
